import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=3f3874fe"
import script from "./dashboards.ts?vue&type=script&lang=js&external"
export * from "./dashboards.ts?vue&type=script&lang=js&external"
import style0 from "./dashboards.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports